import React from "react";
import { InfoIcon } from "@phosphor-icons/react";
import { useTranslate } from "@refinedev/core";
import { FooterNote, FooterText } from "./styles";

export const EncryptedNote: React.FC = () => {
  const t = useTranslate();

  return (
    <FooterNote>
      <InfoIcon size={13} color="#6EA29F" />
      <FooterText>{t("pages.home.securityNote")}</FooterText>
    </FooterNote>
  );
};
